import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import withProps from 'recompose/withProps';
import Layout from '@4c/layout';

import withReservation from '../utils/Reservation';
import Card from './Card';
import CartCard from './CartCard';
import FormattedPrice from './FormattedPrice';
import LinkButton from './LinkButton';
import PageSegment from './PageSegment';
import PrinterIcon from './PrinterIcon';

const Address = ({ address }) => (
  <Layout direction="column" pad={4} grow>
    <address>
      <div>{address.name}</div>
      {address.attention && (
        <FormattedMessage
          tagName="div"
          id="orderSummary.attention"
          defaultMessage="attn: {attention}"
          values={{ attention: address.attention }}
        />
      )}
      <div>
        {address.line1} {address.line2}
      </div>
      <div>
        {address.city}, {address.state} {address.postalCode}
      </div>
    </address>
    <Layout.Spacer />
    {!!address.phone && (
      <div>
        <div>
          <FormattedMessage
            defaultMessage="Phone number:"
            id="confirmation.phone"
          />
        </div>
        <div>{address.phone}</div>
      </div>
    )}
  </Layout>
);

const PrintButton = styled(LinkButton, null, "PrintButton", require("./OrderSummarySegment-PrintButton.module.scss"), "print-button", "printButton");

const Column = withProps({
  display: 'flex',
  direction: 'column',
  noBorder: true,
  grow: true,
})(
  styled(Card.Segment, null, "Column", require("./OrderSummarySegment-Column.module.scss"), "column", "column"),
);

const CardHeading = styled('header', null, "CardHeading", require("./OrderSummarySegment-CardHeading.module.scss"), "card-heading", "cardHeading");

function print(event) {
  event.preventDefault();
  // i've no idea why the timeout is required, but it produces better results...
  setTimeout(() => window.print());
}

const propTypes = {};

function OrderSummarySegment({ cart }) {
  const { payment } = cart.remote;
  return (
    <PageSegment theme="light" align="center">
      <PageSegment.Content pad={4} maxWidthMd flushSm>
        <PageSegment.Heading level="2">
          <FormattedMessage
            id="orderSummarySegment.title"
            defaultMessage="Order Summary"
          />
          <PrintButton onClick={print}>
            <PrinterIcon />
            <FormattedMessage
              id="orderSummarySegment.print"
              defaultMessage="Print"
            />
          </PrintButton>
        </PageSegment.Heading>
        <Card direction="row" wrap>
          <Column fillMd>
            <CardHeading>
              <FormattedMessage
                id="orderSummarySegment.total"
                defaultMessage="Total"
              />
            </CardHeading>
            <FormattedPrice value={cart.total} />
          </Column>

          <Column>
            <CardHeading>
              <FormattedMessage
                id="orderSummarySegment.shippingAddress"
                defaultMessage="Delivery Address"
              />
            </CardHeading>
            <Address address={cart.shippingAddress} email={cart.email} />
          </Column>

          <Column>
            <CardHeading>
              <FormattedMessage
                id="orderSummarySegment.billingAddress"
                defaultMessage="Billing address"
              />
            </CardHeading>
            <Address address={cart.billingAddress} email={cart.email} />
          </Column>
          <Column fillMd>
            <CardHeading>
              <FormattedMessage
                id="orderSummarySegment.payment"
                defaultMessage="Payment"
              />
            </CardHeading>
            {cart.remote.payment.quoteRequested ? (
              <div>
                <FormattedMessage
                  defaultMessage="Electronic Quote Sent"
                  id="orderSummarySegment.quoteRequested"
                />
              </div>
            ) : (
              <>
                <div>{payment.source.brand}</div>
                <div>
                  *********
                  {payment.source.last4}
                </div>
                <div>
                  Expiration:{' '}
                  {String(payment.source.expMonth).padStart(2, '0')}/
                  {payment.source.expYear}
                </div>
              </>
            )}
          </Column>
        </Card>
        <br />
        <CartCard editable={false} />
      </PageSegment.Content>
    </PageSegment>
  );
}

OrderSummarySegment.propTypes = propTypes;

export default withReservation(OrderSummarySegment);
